<template>
    <div class="about__list">
        <div class="about__item" v-for="(v, i) in dataLottoLucky" :key="i">
            <h5 class="about__item-title">
                {{ getTranslatedText(v.title) }}
            </h5>
            <p class="about__item-des">
                {{ getTranslatedText(v.description) }}
            </p>
            <div class="about__item-table">
                <div class="about__item-table__column header">
                    <div class="about__item-table__column-item">
                        <span class="about__item-table__column-item-text">
                            {{ getTranslatedText('Numéros Gagnants') }}
                        </span>
                    </div>
                    <div class="about__item-table__column-item center">
                        <span class="about__item-table__column-item-text">
                            {{ getTranslatedText('Mise') }}
                        </span>
                    </div>
                    <div class="about__item-table__column-item">
                        <span class="about__item-table__column-item-text">
                            {{ getTranslatedText('Gains') }}
                        </span>
                    </div>
                </div>
                <div class="about__item-table__column body">
                    <div class="about__item-table__columm__item number">
                        <div
                            class="about__item-table__column-item"
                            v-for="(N, NIndex) in v.column.number"
                            :key="NIndex"
                        >
                            <span class="about__item-table__column-item-text">
                                {{ N.replace(/\[Numéros\]/g, getTranslatedText('Numéros')) }}
                            </span>
                        </div>
                    </div>
                    <div class="about__item-table__columm__item">
                        <div class="about__item-table__column-item no-border center">
                            <span class="about__item-table__column-item-text bold">
                                {{ getTranslatedText(v.column.mise) }}
                            </span>
                        </div>
                    </div>
                    <div class="about__item-table__columm__item">
                        <div class="about__item-table__column-item" v-for="(G, GIndex) in v.column.gains" :key="GIndex">
                            <span class="about__item-table__column-item-text price">
                                {{ getTranslatedText(G) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import { lotoLucky } from '@/resource/about/loto';

export default {
    mixins: [languageMixins],
    data() {
        return {
            dataLottoLucky: lotoLucky,
        };
    },
};
</script>
